import { render, staticRenderFns } from "./DisplayCouverturesFilter.vue?vue&type=template&id=59252015"
import script from "./DisplayCouverturesFilter.vue?vue&type=script&lang=js"
export * from "./DisplayCouverturesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports